import { useEffect, useState } from "react";

/** "1:05" (m:ss), or "1:02:05" past an hour. Null for a missing or bad stamp. */
export function formatElapsed(since: string | null | undefined, now: number): string | null {
  if (!since) return null;
  const start = new Date(since).getTime();
  if (Number.isNaN(start)) return null;
  const total = Math.max(0, Math.floor((now - start) / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = String(total % 60).padStart(2, "0");
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${s}` : `${m}:${s}`;
}

/**
 * A running "· 1:05 so far" for machine work in progress (planning a month,
 * writing ideas, rewriting one). It ticks every second on its own, so only this
 * label re-renders: the page's minute clock (useStuckClock) is too coarse for a
 * timer the reader watches, and it does not run while a month is planning.
 */
export default function ElapsedSince({
  since,
  prefix = " · ",
  suffix = " so far",
}: {
  since: string | null | undefined;
  prefix?: string;
  suffix?: string;
}) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!since) return;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [since]);

  const label = formatElapsed(since, now);
  return label ? (
    <span className="tabular-nums">
      {prefix}
      {label}
      {suffix}
    </span>
  ) : null;
}
